import { useInfiniteQuery } from '@tanstack/react-query';

import PromptsService, { FilterPromptsDto } from '@/services/PromptsService';

export const GET_PROMPTS_QUERY_KEY = (filters: FilterPromptsDto) => [
  'prompts',
  filters,
];

export function useGetPrompts(filters: Omit<FilterPromptsDto, 'currentPage'>) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: GET_PROMPTS_QUERY_KEY(filters),
      initialPageParam: 1,
      queryFn: ({ pageParam }) =>
        PromptsService.getPrompts({
          ...filters,
          page: pageParam,
          limit: filters.limit ?? 10,
        }),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const { currentPage, totalPages } = lastPage;

        if (currentPage === totalPages || totalPages === 0) {
          return null;
        }

        return lastPageParam + 1;
      },
    });

  const prompts = data?.pages.flatMap((page) => page?.items);

  return {
    prompts: prompts ?? [],
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
